var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('ns-track',{directives:[{name:"track",rawName:"v-track.login",value:({ userInfo: _vm.userInfo }),expression:"{ userInfo }",modifiers:{"login":true}}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }